// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vF2qAau2jVhU5WN1xdSO{border:solid 1px;border-radius:3px;height:150px;position:relative;width:268px}.RX04ZvIgrabMseMDquo2{height:200px;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `vF2qAau2jVhU5WN1xdSO`,
	"wrapperSmall": `RX04ZvIgrabMseMDquo2`
};
export default ___CSS_LOADER_EXPORT___;
